import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Content } from "../../../models/response/content/content.model";
import { RootState } from "../../store";

const initialState: Content = {
  crossSelling: false,
};

export const ContentSlice = createSlice({
  name: "content",
  initialState,
  reducers: {
    setContent: (_content: Content, action: PayloadAction<Content>) => {
      return { ...action.payload };
    },
  },
});

export const { setContent } = ContentSlice.actions;

export const selectContent = (state: RootState) => state;

export default ContentSlice.reducer;
